import { render, staticRenderFns } from "./ScienceCard.vue?vue&type=template&id=4b188170"
import script from "./ScienceCard.vue?vue&type=script&lang=js"
export * from "./ScienceCard.vue?vue&type=script&lang=js"
import style0 from "./ScienceCard.vue?vue&type=style&index=0&id=4b188170&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports